"use strict";

export function initInScope ($scope) {
    let $scrollElements = $scope.find('.js-scroll-detect');

    $scrollElements.each(function (e){
        let $thisScrollElement = $(this),
            scrollHeight = $thisScrollElement[0].scrollHeight - 5,
            elementHeight = $thisScrollElement.height();

        if (scrollHeight > elementHeight) {
            $thisScrollElement.find('.js-scroll-detect__info').removeClass('hide');

            $thisScrollElement.scroll(function () {
                let $scrollInfoElement = $(this).find('.js-scroll-detect__info');

                $scrollInfoElement.addClass('hide');
                $thisScrollElement.off('scroll');
            });
        }

    });
}